import React, { useState, useEffect, useRef } from "react";
import useMediaQuery from "hooks/useMediaQuery";
import { useNavigate, useLocation } from "react-router-dom";

import styles from "./Gnb.module.css";
import logo from "assets/svg/logo.svg";
import menu from "assets/svg/Hamburger.svg";

export default function Gnb() {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width: 1023px)");
    const [isOpen, setIsOpen] = useState(false);

    const menuRef = useRef(null);      // 📌 드롭다운 DOM 참조
    const buttonRef = useRef(null);    // 📌 메뉴 버튼 DOM 참조

    // 📌 메뉴 바깥 클릭 시 닫기
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target) // 버튼도 예외 처리
            ) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const navi = [
        { idx: 0, name: "메인", path: "/" },
        { idx: 1, name: "서비스 소개", path: "/service" },
        { idx: 2, name: "사용가이드", path: "/guide" },
        { idx: 3, name: "이용약관", path: "/term" },
        { idx: 4, name: "Contact Us", path: "/contact" },
    ];

    return (
        <>
            {isMobile ? (
                <div className={styles.gnb}>
                    <div className={styles.gnbMobileWraper}>
                        <img
                            src={logo}
                            alt="logo"
                            className={styles.logo}
                            onClick={() => navigate("/")}
                            style={{ cursor: "pointer" }}
                        />
                        <img
                            src={menu}
                            alt="menu"
                            ref={buttonRef} // 📌 버튼에도 ref 적용
                            className={styles.menuIcon}
                            onClick={() => setIsOpen((prev) => !prev)}
                            style={{ cursor: "pointer" }}
                        />
                    </div>

                    {/* 📌 드롭다운 메뉴 */}
                    {isOpen && (
                        <div className={styles.mobileMenu} ref={menuRef}>
                            {navi.map((item) => (
                                <div
                                    key={item.idx}
                                    className={`${styles.mobileNavItem} ${location.pathname === item.path ? styles.active : ""
                                        }`}
                                    onClick={() => {
                                        navigate(item.path);
                                        setIsOpen(false);
                                    }}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ) : (
                <div className={styles.gnb}>
                    <div className={styles.gnbContents}>
                        <img
                            src={logo}
                            alt="logo"
                            className={styles.logo}
                            onClick={() => navigate("/")}
                            style={{ cursor: "pointer" }}
                        />
                        <div className={styles.navigater}>
                            {navi.map((item) => (
                                <div
                                    key={item.idx}
                                    className={`${styles.navItem} ${location.pathname === item.path ? styles.active : ""
                                        }`}
                                    onClick={() => navigate(item.path)}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
